import { checkNoChosenYears } from 'portfolio3/features/pdf/utils/checkNoChosenYears';
import { checkSectionEmptiness } from 'portfolio3/features/pdf/utils/checkSectionEmptiness';
import { sortPeriods } from 'portfolio3/features/pdf/utils/sortPeriods';
import { createSelector } from 'reselect';
import { chosenYearsSelector } from 'selectors/drawers';
import { academicYearsTouchedSelector } from 'selectors/drawers/linkSharingDrawer';

import { creationClubsYearsSelector } from './creationClubsYearsSelector';
import { creationContestsYearsSelector } from './creationContestsYearsSelector';
import { creationOccupationsYearsSelector } from './creationOccupationsYearsSelector';
import { creationRewardsYearsSelector } from './creationRewardsYearsSelector';

export const creationSectionAcademicYearsDataSelector = createSelector(
  [
    // Данные раздела творчество
    creationRewardsYearsSelector,
    creationClubsYearsSelector,
    creationContestsYearsSelector,
    creationOccupationsYearsSelector,
    // Выбранные года
    chosenYearsSelector,
    academicYearsTouchedSelector,
  ],
  (
    creationRewardsYears,
    creationClubsYears,

    creationContestsYears,
    creationOccupationsYears,
    chosenYears,
    academicYearsTouched,
  ) => {
    const emptyDataMap = {
      creationReward: checkNoChosenYears(creationRewardsYears, chosenYears, academicYearsTouched),
      creationClub: checkNoChosenYears(creationClubsYears, chosenYears, academicYearsTouched),
      creationContest: checkNoChosenYears(creationContestsYears, chosenYears, academicYearsTouched),
      creationUnit: checkNoChosenYears(creationOccupationsYears, chosenYears, academicYearsTouched),
    };

    const periods: Set<string> = new Set([
      ...creationRewardsYears,
      ...creationClubsYears,
      ...creationContestsYears,
      ...creationOccupationsYears,
    ]);

    return {
      academicYears: sortPeriods(periods),
      emptyDataMap: {
        ...emptyDataMap,
        creation: checkSectionEmptiness(emptyDataMap),
      },
    };
  },
);
